import React from 'react';

const CheckDoneIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_33344_85557)">
      <path
        d="M5.00002 12.5L6.66669 14.1667L10.4167 10.4167M6.66669 6.66666V4.33332C6.66669 3.3999 6.66669 2.93319 6.84834 2.57667C7.00813 2.26307 7.2631 2.0081 7.5767 1.84831C7.93322 1.66666 8.39993 1.66666 9.33335 1.66666H15.6667C16.6001 1.66666 17.0668 1.66666 17.4233 1.84831C17.7369 2.0081 17.9919 2.26307 18.1517 2.57667C18.3334 2.93319 18.3334 3.3999 18.3334 4.33332V10.6667C18.3334 11.6001 18.3334 12.0668 18.1517 12.4233C17.9919 12.7369 17.7369 12.9919 17.4233 13.1517C17.0668 13.3333 16.6001 13.3333 15.6667 13.3333H13.3334M4.33335 18.3333H10.6667C11.6001 18.3333 12.0668 18.3333 12.4233 18.1517C12.7369 17.9919 12.9919 17.7369 13.1517 17.4233C13.3334 17.0668 13.3334 16.6001 13.3334 15.6667V9.33332C13.3334 8.3999 13.3334 7.93319 13.1517 7.57667C12.9919 7.26307 12.7369 7.0081 12.4233 6.84831C12.0668 6.66666 11.6001 6.66666 10.6667 6.66666H4.33335C3.39993 6.66666 2.93322 6.66666 2.5767 6.84831C2.2631 7.0081 2.00813 7.26307 1.84834 7.57667C1.66669 7.93319 1.66669 8.3999 1.66669 9.33332V15.6667C1.66669 16.6001 1.66669 17.0668 1.84834 17.4233C2.00813 17.7369 2.2631 17.9919 2.5767 18.1517C2.93322 18.3333 3.39993 18.3333 4.33335 18.3333Z"
        stroke="#344054"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_33344_85557">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CheckDoneIcon;
